module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      权限管理\n    ")]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "姓名",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "部门",
      "label-for": "remark"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "remark",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.remark),
      callback: function($$v) {
        _vm.$set(_vm.data, "remark", $$v)
      },
      expression: "data.remark"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "手机号",
      "label-for": "mobile"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "mobile",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.data.mobile),
      callback: function($$v) {
        _vm.$set(_vm.data, "mobile", $$v)
      },
      expression: "data.mobile"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "类型",
      "label-for": "admin_type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "admin_type",
      "options": _vm.admin_types
    },
    model: {
      value: (_vm.data.admin_type),
      callback: function($$v) {
        _vm.$set(_vm.data, "admin_type", $$v)
      },
      expression: "data.admin_type"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "点赞中心权限",
      "label-for": "vote_auth"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "vote_auth",
      "options": _vm.vote_options,
      "name": "radio-options"
    },
    model: {
      value: (_vm.data.vote),
      callback: function($$v) {
        _vm.$set(_vm.data, "vote", $$v)
      },
      expression: "data.vote"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "点赞中心权限（海外版）",
      "label-for": "edition_auth"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "id": "edition_auth",
      "options": _vm.edition_options,
      "name": "edition-radio-options"
    },
    model: {
      value: (_vm.data.edition),
      callback: function($$v) {
        _vm.$set(_vm.data, "edition", $$v)
      },
      expression: "data.edition"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "权限",
      "label-for": "authority"
    }
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "responsive": "sm",
      "items": _vm.data.authority,
      "fields": _vm.service_fields
    },
    scopedSlots: _vm._u([{
      key: "cell(service_code)",
      fn: function(row) {
        return [(_vm.services[row.item.service_code]) ? _c('span', [_vm._v(_vm._s(_vm.services[row.item.service_code]))]) : _c('span', [_c('b-form-select', {
          attrs: {
            "id": "service",
            "options": _vm.filteredServices,
            "size": "sm"
          },
          model: {
            value: (row.item.service_code),
            callback: function($$v) {
              _vm.$set(row.item, "service_code", $$v)
            },
            expression: "row.item.service_code"
          }
        })], 1)]
      }
    }, {
      key: "cell(show_details)",
      fn: function(row) {
        return [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return row.toggleDetails.apply(null, arguments)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-gear"
        })]), _vm._v(" "), _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              return _vm.data.authority.splice(row.index, 1)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-minus"
        })]), _vm._v(" "), (_vm.displayAddService(row, _vm.data.authority)) ? _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              return _vm.addService(_vm.data.authority)
            }
          }
        }, [_c('span', {
          staticClass: "fa fa-plus"
        })]) : _vm._e()]
      }
    }, {
      key: "cell(row-details)",
      fn: function(row) {
        return [_c('b-card', _vm._l((row.item.authority), function(p_auth, index) {
          return _c('b-row', {
            key: p_auth.product_code,
            staticClass: "mb-2"
          }, [_c('b-col', {
            attrs: {
              "sm": "2"
            }
          }, [(p_auth.product_code) ? _c('b', [_vm._v(_vm._s(_vm.products[p_auth.product_code]))]) : _c('b', [_c('b-form-select', {
            attrs: {
              "id": "product",
              "options": _vm.filteredProducts(row.item.authority),
              "size": "sm"
            },
            model: {
              value: (p_auth.product_code),
              callback: function($$v) {
                _vm.$set(p_auth, "product_code", $$v)
              },
              expression: "p_auth.product_code"
            }
          })], 1)]), _vm._v(" "), _c('b-col', [_c('b-form-select', {
            attrs: {
              "options": _vm.roles,
              "size": "sm",
              "von-change": _vm.changePerm([p_auth.role_id, p_auth])
            },
            model: {
              value: (p_auth.role_id),
              callback: function($$v) {
                _vm.$set(p_auth, "role_id", $$v)
              },
              expression: "p_auth.role_id"
            }
          }), _vm._v(" "), _c('b-form-checkbox-group', {
            attrs: {
              "name": "authority",
              "disabled": true,
              "options": _vm.getAuthOptions(p_auth.mask)
            },
            model: {
              value: (p_auth.mask),
              callback: function($$v) {
                _vm.$set(p_auth, "mask", $$v)
              },
              expression: "p_auth.mask"
            }
          })], 1), _vm._v(" "), _c('b-col', {
            attrs: {
              "sm": "2"
            }
          }, [_c('b-button', {
            staticClass: "mr-2",
            attrs: {
              "size": "sm",
              "variant": "outline-danger"
            },
            on: {
              "click": function($event) {
                return _vm.removeProduct(row, index, _vm.data.authority)
              }
            }
          }, [_c('span', {
            staticClass: "fa fa-minus"
          })]), _vm._v(" "), (_vm.displayAddProduct(p_auth, index, row.item.authority)) ? _c('b-button', {
            staticClass: "mr-2",
            attrs: {
              "size": "sm",
              "variant": "outline-success"
            },
            on: {
              "click": function($event) {
                return _vm.addProduct(row.item.authority)
              }
            }
          }, [_c('span', {
            staticClass: "fa fa-plus"
          })]) : _vm._e()], 1)], 1)
        }), 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "size": "sm",
      "variant": "outline-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" 提交")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "reset",
      "size": "sm",
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" 返回")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a03ae710!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/AdminUpdate.vue
// module id = 7Ddl
// module chunks = 4